// REACT
import React, { Dispatch, SetStateAction, useState, useEffect } from 'react'

// ROUTER
import { BrowserRouter, Switch, Route } from 'react-router-dom'

// ESTILOS
import 'Icons/Icons.css'

// STRINGS
import Strings from 'Lang/Strings.json'

// PAGINAS
import Reservations from 'Pages/Reservations/Reservations'
import Index from 'Pages/Index/Index'

// CONTEXTO
import MainContext from 'Context/MainContext'

// COMPONENTES
import Navbar from 'Components/Navbar/Navbar'
import Footer from 'Components/Footer/Footer'

// PAGINAS
import Policies from 'Pages/Policies/Policies'
import Rooms from 'Pages/Rooms/Rooms'
import Gallery from 'Pages/Gallery/Gallery'

// ESTADO
interface AppState {
	langCode: string
	lang: ILangPackage
}

// ESTADO POR DEFECTO
const DefState: AppState = {
	langCode: 'ES',
	lang: Strings.es,
}

const App: React.FC = () => {
	// ESTADO
	const [state, setState]: [AppState, Dispatch<SetStateAction<AppState>>] = useState(DefState)

	// CAMBIAR LENGUAJE
	const changeLang = (mode: number) => {
		// DETECTAR LENGUAJE
		const langCode: string = mode === 0 ? 'ES' : mode === 1 ? 'EN' : 'FR'
		const lang: ILangPackage = mode === 0 ? Strings.es : mode === 1 ? Strings.en : Strings.fr

		// GUARDAR LENGUAJE
		window.localStorage.setItem('lang', langCode)

		// CAMBIAR ESTADO
		setState({ langCode, lang })
	}

	// LEER VARIABLES
	useEffect(() => {
		// LEER VARIABLES
		const localCode: string | null = window.localStorage.getItem('lang')
		let langCode: string = 'ES'

		// ASIGNAR CODIGO
		if (localCode) langCode = localCode

		// ACTUALIZAR ESTADO
		changeLang(langCode === 'ES' ? 0 : langCode === 'EN' ? 1 : 2)
	}, [])

	return (
		<MainContext.Provider value={{ ...state }}>
			<BrowserRouter>
				<Navbar changeLang={changeLang} />
				<Switch>
					<Route exact path='/'>
						<Index />
					</Route>
					<Route exact path='/reservaciones'>
						<Reservations />
					</Route>
					<Route exact path='/politicas'>
						<Policies />
					</Route>
					<Route exact path='/habitaciones'>
						<Rooms />
					</Route>
					<Route exact path='/galeria'>
						<Gallery />
					</Route>
				</Switch>
				<Footer />
			</BrowserRouter>
		</MainContext.Provider>
	)
}

export default App
